import React, { useEffect, useState, useMemo, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { Parallax } from "react-parallax";
import { Link, useNavigate } from "react-router-dom";
import Navbar from '../../layout/Navbar';
import Preloader from '../../layout/preloader';
import Footer from '../../section-pages/footer';
import ScrollToTopBtn from '../../layout/ScrollToTop';
import { createGlobalStyle } from 'styled-components';
import { handleRegister } from '../../api';
import { useFormik } from 'formik';
import { Modal, Button, Dropdown } from 'react-bootstrap';
import { utils, writeFile } from 'xlsx';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { use } from 'react';
import moment from "moment";



const image1 = "./img/background/5.webp";

const GlobalStyles = createGlobalStyle`
  .react-parallax-bgimage {
    transform: translate3d(-50%, 0, 0px) !important;
  }
`;

const defaultMarkup = {
  distributor: 0.3,
  retailer: 0.4,
};

const sampleIngredientSuggestions = [
  { name: 'Garlic', unitCost: 0.75 },
  { name: 'Lime Juice', unitCost: 1.1 },
  { name: 'Cilantro', unitCost: 0.9 },
  { name: 'Salt', unitCost: 0.5 },
  { name: 'Vinegar', unitCost: 1.3 },
];

const existingRecipes = ["Salsa Verde", "Spicy Tomato Dip"];

const ProductionBatchForm = ({
  setShow,
  show = false,
  recipeSummaryList = []
}) => {
  const [formData, setFormData] = useState({
    productName: 'Don Geraldo Foods',
    expectedYield: '12 16oz tubs',
    recipeName: 'New Mexico Style Salsa Medium',
    expirationCode: 'EXP0426',
    packagingSize: '16oz tubs - 12 per case',
    criticalPoint: 'Mix for 2 minutes until homogeneous',
    phPackingTemp: 'pH 4.2 / 38°F',
    allergen: 'None declared',
    ingredients: [
      { name: 'Chopped Tomatoes', quantity: '9.9 #' },
      { name: 'Onions', quantity: '3.3 #' },
      { name: 'Jalapeños', quantity: '0.5 #' },
      { name: 'Cilantro', quantity: '0.6 #' },
      { name: 'Garlic (minced)', quantity: '0.63 #' },
      { name: 'Lemon Juice', quantity: '1.33 #' },
      { name: 'Salt', quantity: '0.23 #' },
      { name: 'Cumin & Spices Blend', quantity: '0.01 #' },
    ],
    notes: `Tomatoes are chopped and drained.\nWeight before drain: 9.9 lbs.\nWeight after drain: 7.34 lbs.\n\nPulse chop onions, garlic, cilantro, and jalapeños.\nCombine all ingredients including spices and lemon juice.\nMix thoroughly until well integrated.`,
    packaging: 'Fill tubs to just below rim. Seal and label each tub. Store refrigerated.',
  });


  useEffect(() => {
    if (recipeSummaryList?.[0]) {
      const info = { ...formData }
      info['ingredients'] = recipeSummaryList?.map(res => {
        return {
          name: res?.name,
          quantity: `${res?.totalOz} #`
        }
      })
      setFormData(info)

    }

  }, [
    recipeSummaryList
  ])

  // const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);
  const printRef = useRef();

  const handleDownloadPDF = async () => {
    const canvas = await html2canvas(printRef.current);
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'pt', 'a4');
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save('production-batch.pdf');
  };

  const handleDownloadExcel = () => {
    const wsData = [
      ['Product Name', formData.productName],
      ['Expected Yield', formData.expectedYield],
      ['Recipe Name', formData.recipeName],
      ['Expiration Code', formData.expirationCode],
      ['Packaging Size', formData.packagingSize],
      ['Critical Point', formData.criticalPoint],
      ['Packing Temperature', formData.phPackingTemp],
      ['Allergen', formData.allergen],
      [],
      ['Ingredients', 'Quantity or Weight', 'Lot Number', 'Supplier'],
      ...formData.ingredients.map((item, idx) => [
        item.name,
        item.quantity,
        `LOT2025-${idx + 1}`,
        `Local Farm #${(idx % 3) + 1}`,
      ]),
      [],
      ['Notes'],
      [formData.notes],
      [],
      ['Packaging'],
      [formData.packaging],
    ];
    const wb = utils.book_new();
    const ws = utils.aoa_to_sheet(wsData);
    utils.book_append_sheet(wb, ws, 'Batch');
    writeFile(wb, 'production-batch.xlsx');
  };

  return (
    <Modal show={show} onHide={handleClose} size="xl">
      <Modal.Body>
        <div className="d-flex justify-content-end mb-3">
          <Dropdown>
            <Dropdown.Toggle variant="outline-primary">Export</Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={handleDownloadPDF}>Download as PDF</Dropdown.Item>
              <Dropdown.Item onClick={handleDownloadExcel}>Download as Excel</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div ref={printRef} style={{ fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>
          <table className="table table-bordered mb-4">
            <thead>
              <tr>
                <th colSpan="4" className="text-center text-uppercase">Production Batch Tracking Sheet</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Product Name:</strong> {formData.productName}</td>
                <td colSpan="3"><strong>Expected Yield:</strong> {formData.expectedYield}</td>
              </tr>
              <tr>
                <td rowSpan="2" style={{ verticalAlign: 'top' }}>
                  <div className="text-center mt-4">
                    <strong>{formData.recipeName}</strong>
                  </div>
                </td>
                <td><strong>Code or Expiration Date:</strong> {formData.expirationCode}</td>
                <td><strong>Packaging Size:</strong> {formData.packagingSize}</td>
              </tr>
              <tr>
                <td><strong>Critical Point/Duration:</strong> {formData.criticalPoint}</td>
                <td><strong>Packing Temperature:</strong> {formData.phPackingTemp}</td>
              </tr>
              <tr>
                <td><strong>PH</strong></td>
                <td colSpan="3"><strong>W.A.</strong> <span className="float-end">Allergen: {formData.allergen}</span></td>
              </tr>
            </tbody>
          </table>

          <table className="table table-bordered mb-4">
            <thead className="table-light">
              <tr>
                <th>Ingredients</th>
                <th>Quantity or Weight</th>
                <th>Ingredient Code or Lot Number</th>
                <th>Supplier</th>
              </tr>
            </thead>
            <tbody>
              {formData.ingredients.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.name}</td>
                  <td>{item.quantity}</td>
                  <td>LOT2025-{idx + 1}</td>
                  <td>Local Farm #{(idx % 3) + 1}</td>
                </tr>
              ))}
              {Array.from({ length: 4 }).map((_, idx) => (
                <tr key={`extra-${idx}`}>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </table>

          <table className="table table-bordered mb-4">
            <thead>
              <tr>
                <th colSpan="4">Notes:</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="4">
                  <pre className="m-0" style={{ whiteSpace: 'pre-wrap', border: 'none', background: 'none' }}>{formData.notes}</pre>
                </td>
              </tr>
            </tbody>
          </table>

          <table className="table table-bordered">
            <thead>
              <tr>
                <th colSpan="4">Packaging:</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="4" style={{ minHeight: '40px' }}>{formData.packaging}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};




export default ProductionBatchForm;

